import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetothanecab() {



const cardData = {
  keyword: " Pune to Thane Cab ",

"headingDescription": "SRS Cab Service offers Pune to Thane Cab, providing a comfortable, safe, and efficient travel solution for families, professionals, and daily commuters. Our well-maintained vehicles, experienced drivers, and timely pickups ensure a smooth and hassle-free journey from Pune to Thane. Ideal for business trips, city transfers, and weekend travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and reliable travel experience.",
"topPlaces": [
  {
    "title": "Upvan Lake",
    "description": "Upvan Lake is a scenic and peaceful spot in Thane surrounded by hills. Travelers using SRS Cab Service from Pune often visit for relaxation, evening walks, and beautiful sunset views."
  },
  {
    "title": "Yeoor Hills",
    "description": "Yeoor Hills is a green and serene area located within Sanjay Gandhi National Park. Visitors using SRS Cab Service often explore this destination for nature walks and fresh air."
  },
  {
    "title": "Masunda Lake",
    "description": "Masunda Lake, also known as Talao Pali, is a popular recreational spot in Thane. Travelers using SRS Cab Service often enjoy boating and local street food here."
  },
  {
    "title": "Suraj Water Park",
    "description": "Suraj Water Park is a well-known amusement park in Thane. Visitors using SRS Cab Service often include this destination for family outings and fun activities."
  },
  {
    "title": "Viviana Mall",
    "description": "Viviana Mall is one of the largest shopping malls in Thane. Travelers using SRS Cab Service often visit for shopping, dining, and entertainment."
  },
  {
    "title": "Korum Mall",
    "description": "Korum Mall is a popular shopping destination in Thane. Visitors using SRS Cab Service often explore this mall for leisure and retail therapy."
  },
  {
    "title": "Tikuji-ni-Wadi",
    "description": "Tikuji-ni-Wadi is a resort and amusement park in Thane. Travelers using SRS Cab Service often visit for family fun, water rides, and relaxation."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green space near Thane known for wildlife and trekking. Visitors using SRS Cab Service often explore its natural beauty and outdoor activities."
  },
  {
    "title": "Kelva Beach",
    "description": "Kelva Beach is a serene coastal destination near Thane. Travelers using SRS Cab Service often visit this beach for a peaceful getaway."
  },
  {
    "title": "Ghodbunder Fort",
    "description": "Ghodbunder Fort is a historic fort offering scenic views and heritage value. Visitors using SRS Cab Service often explore this site for history and photography."
  }
],



services: [
{
name: "Thane to Pune Cab Fare",
description: "Thane to Pune cab fare provides estimated pricing for intercity travel. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Cab from Thane to Pune",
description: "Cab from Thane to Pune offers reliable transportation for business and personal trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Kalyan Cab Service",
description: "Pune to Kalyan cab service provides convenient travel for intercity journeys. Customers can book cabs for business and leisure trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Thane Taxi",
description: "Pune Thane taxi offers dependable travel for daily and outstation trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Thane Cab Booking",
description: "Pune to Thane cab booking offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune to Thane Cab Fare",
description: "Pune to Thane cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Thane Cab Service",
description: "Pune to Thane cab service offers reliable transportation for intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Thane One Way Cab",
description: "Pune to Thane one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Thane Taxi Service",
description: "Pune to Thane taxi service provides convenient travel options for passengers. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Thane to Pune Cab Booking",
description: "Thane to Pune cab booking offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune to Badlapur Cab",
description: "Pune to Badlapur cab offers reliable intercity travel for customers. Users can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Vasai Virar Cab",
description: "Pune to Vasai Virar cab provides convenient travel for long-distance trips. Customers can book cabs for business and leisure journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Vashi Cab",
description: "Pune to Vashi cab offers reliable transportation for intercity travel. Customers can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Thane Round Trip Cab",
description: "Pune to Thane round trip cab provides convenient two-way travel options. Customers can book cabs for return journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Pune to Kurla Dadar Taxi",
description: "Pune to Kurla Dadar taxi offers reliable travel to central Mumbai locations. Customers can book taxis for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Thane Tempo Traveller on Rent",
description: "Pune to Thane tempo traveller on rent offers group travel solutions. Customers can book spacious vehicles for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Pune Thane Round Trip Cab",
description: "Pune Thane round trip cab offers flexible travel for return journeys. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Pune to Thane Innova Cab",
description: "Pune to Thane Innova cab offers premium SUV travel for comfort. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family travel. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
},
{
name: "Pune to Thane Taxi Booking",
description: "Pune to Thane taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily."
},
{
name: "Pune to Thane One Way Taxi",
description: "Pune to Thane one way taxi offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "Pune to Thane Taxi Price",
description: "Pune to Thane taxi price provides estimated cost details for travel planning. Customers can compare prices before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi price services."
},
{
name: "Pune to Thane Cab Hire",
description: "Pune to Thane cab hire offers flexible vehicle options for long-distance travel. Customers can hire cabs for personal and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Pune to Thane Taxi Hire",
description: "Pune to Thane taxi hire provides convenient transportation for intercity travel. Customers can hire taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Pune to Thane Outstation Cab",
description: "Pune to Thane outstation cab offers reliable travel for long-distance trips. Customers can book cabs for business and leisure journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Pune to Thane Outstation Taxi",
description: "Pune to Thane outstation taxi provides convenient travel options for intercity trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation taxi services."
},
{
name: "Pune to Thane Drop Taxi",
description: "Pune to Thane drop taxi offers direct transportation for single-direction journeys. Customers can book taxis for quick travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with drop taxi services."
}
],

tableData: [
["Thane to Pune Cab Fare","Cab from Thane to Pune"],
["Pune to Kalyan Cab Service","Pune Thane Taxi"],
["Pune to Thane Cab Booking","Pune to Thane Cab Fare"],
["Pune to Thane Cab Service","Pune to Thane One Way Cab"],
["Pune to Thane Taxi Service","Thane to Pune Cab Booking"],
["Pune to Badlapur Cab","Pune to Vasai Virar Cab"],
["Pune to Vashi Cab","Pune to Thane Round Trip Cab"],
["Pune to Kurla Dadar Taxi","Pune to Thane Tempo Traveller on Rent"],
["Pune Thane Round Trip Cab","Pune to Thane Innova Cab"],
["Pune to Thane Taxi Booking","Pune to Thane One Way Taxi"],
["Pune to Thane Taxi Price","Pune to Thane Cab Hire"],
["Pune to Thane Taxi Hire","Pune to Thane Outstation Cab"],
["Pune to Thane Outstation Taxi","Pune to Thane Drop Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers familiar with the Mumbai-Pune Expressway, ensuring safe, fast, and smooth travel from Pune to Thane."
  },
  {
    WhyChooseheading: "Affordable Pune to Thane Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Thane cab services with transparent pricing. Customers receive full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Thane cab bookings, making it convenient for business travel, airport transfers, and daily commuting."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a comfortable journey from Pune to Thane."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and same-day return options for Pune to Thane travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individual, family, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Thane cab bookings due to punctual drivers, reliable vehicles, and professional service."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Thane cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Thane." },
  { question: "How far is Thane from Pune?", answer: "The distance between Pune and Thane is approximately 150 km and the journey takes around 2.5 to 4 hours depending on traffic. :contentReference[oaicite:0]{index=0}" },
  { question: "Is Pune to Thane cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "What is the starting fare for Pune to Thane cab?", answer: "The one-way cab fare typically starts from around ₹1800 to ₹2500 depending on vehicle type and availability. :contentReference[oaicite:1]{index=1}" },
  { question: "Which vehicles are available for Pune to Thane travel?", answer: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Thane?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is same-day return possible?", answer: "Yes, we offer same-day return cab packages for Pune to Thane travel." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Thane cab service online or via phone." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Deshmukh",
    feedback:
      "Booked SRS Cab Service for Pune to Thane trip. Very smooth journey via expressway and driver was professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Kulkarni",
    feedback:
      "Best Pune to Thane cab service. On-time pickup, clean car, and comfortable ride.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Thane Cab Service - SRS Cab & Tours",
  "description": "Reliable cab service from Pune to Thane, Kalyan, Badlapur, Vasai Virar, Vashi, and nearby areas. Book one-way, round trip, or luxury cabs at affordable rates.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pune-to-thane-cab",
  "areaServed": [
    "Thane, Maharashtra",
    "Kalyan, Maharashtra",
    "Badlapur, Maharashtra",
    "Vasai Virar, Maharashtra",
    "Vashi, Maharashtra"
  ],
  "openingHours": "Mo-Su 06:00-22:00",
  "priceRange": "₹₹₹",
  "serviceType": [
    "One Way Cab Pune to Thane",
    "Round Trip Cab Pune to Thane",
    "Luxury Cab Services",
    "Private Car Hire",
    "Outstation Taxi"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "987"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Pune to Thane Cab Service | SRS Cab & Tours</title>
  <meta 
    name="description" 
    content="Book reliable Pune to Thane cab services. One-way, round trip, or luxury cabs available. Serving Kalyan, Badlapur, Vasai Virar, Vashi & Thane. Affordable taxi rates." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetothanecab;